const VueCookies = require('vue-cookies')
const { v4: uuidv4 } = require('uuid')
const { cookieEnabled } = require('./features')

const retrieveCookieUserId = () => {
  let cookieUserId = VueCookies.get('cookie_user_id')

  if (!cookieEnabled()) {
    cookieUserId = uuidv4()
  } else if (!cookieUserId || cookieUserId === 'null') {
    cookieUserId = uuidv4()
    if (cookieEnabled()) VueCookies.set('cookie_user_id', cookieUserId, '7d')
  } else {
    cookieUserId = VueCookies.get('cookie_user_id')
    if (cookieEnabled()) VueCookies.set('cookie_user_id', cookieUserId, '7d')
  }

  return cookieUserId
}

module.exports = {
  retrieveCookieUserId
}
